import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, timeout: 120000 });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("medlogix_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem("medlogix_token");
      localStorage.removeItem("medlogix_user");
      if (!window.location.pathname.startsWith("/login")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export const auth = {
  async login(email, password) {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("medlogix_token", data.token);
    localStorage.setItem("medlogix_user", JSON.stringify(data.user));
    return data;
  },
  logout() {
    localStorage.removeItem("medlogix_token");
    localStorage.removeItem("medlogix_user");
    localStorage.removeItem("medlogix_session_id");
    sessionStorage.removeItem("aria_briefed_today");
  },
  user() {
    try {
      return JSON.parse(localStorage.getItem("medlogix_user") || "null");
    } catch {
      return null;
    }
  },
  async ackBAA() {
    await api.post("/auth/ack-baa", { acknowledged: true });
    const u = auth.user();
    if (u) {
      u.baa_acknowledged = true;
      localStorage.setItem("medlogix_user", JSON.stringify(u));
    }
  },
};

export const ensureSeed = async () => {
  try { await api.post("/seed"); } catch (e) { /* ignore */ }
};

/**
 * Submit a job-based AI request and poll until completion.
 * @param {string} endpoint - POST endpoint path (e.g. "/ai/soap")
 * @param {object} payload
 * @param {object} opts { intervalMs=3000, timeoutMs=240000, onProgress }
 * @returns {Promise<object>} job.result on success
 */
export async function aiJob(endpoint, payload, opts = {}) {
  const { intervalMs = 3000, timeoutMs = 240000, onProgress } = opts;
  const { data: created } = await api.post(endpoint, payload);
  const jobId = created.job_id;
  if (!jobId) return created; // backward-compat (some endpoints may still be sync)
  const start = Date.now();
  while (Date.now() - start < timeoutMs) {
    await new Promise((r) => setTimeout(r, intervalMs));
    const { data: job } = await api.get(`/jobs/${jobId}`);
    if (onProgress) onProgress(job);
    if (job.status === "done") return job.result;
    if (job.status === "failed") throw new Error(job.error || "Job failed");
  }
  throw new Error("Timed out waiting for AI generation");
}

